module.exports = __webpack_public_path__ + "static/media/WhipAround_android_3_preview.898d254a.jpg";